var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 85,
    viewBox: "0 0 86 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_564_3581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.0001 85C66.196 85 85.0001 66.196 85.0001 43C85.0001 19.804 66.196 1 43.0001 1C19.8041 1 1.00006 19.804 1.00006 43C1.00006 66.196 19.8041 85 43.0001 85Z",
    fill: "url(#paint0_linear_564_3581)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_564_3581)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43.1787,
    cy: 42.1064,
    r: 25.3787,
    fill: "#FF3030"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.5024 43L51.1573 38.3631C51.5934 37.9044 51.8323 37.2948 51.8233 36.6637C51.8143 36.0327 51.5581 35.43 51.1091 34.9837C50.6601 34.5375 50.0538 34.2828 49.4188 34.2739C48.7839 34.2649 48.1705 34.5024 47.709 34.9359L43.0437 39.5728L38.3888 34.9359C38.1648 34.7002 37.8955 34.5117 37.5969 34.3813C37.2983 34.2509 36.9765 34.1813 36.6503 34.1768C36.3242 34.1722 36.0005 34.2326 35.6983 34.3545C35.3961 34.4765 35.1216 34.6574 34.891 34.8866C34.6603 35.1158 34.4783 35.3887 34.3556 35.689C34.233 35.9894 34.1721 36.3112 34.1768 36.6353C34.1814 36.9594 34.2513 37.2793 34.3825 37.5761C34.5137 37.8729 34.7035 38.1405 34.9405 38.3631L39.6032 43L34.9405 47.6369C34.7035 47.8596 34.5137 48.1272 34.3825 48.424C34.2513 48.7208 34.1814 49.0407 34.1768 49.3648C34.1721 49.6889 34.233 50.0107 34.3556 50.311C34.4783 50.6114 34.6603 50.8843 34.891 51.1135C35.1216 51.3427 35.3961 51.5236 35.6983 51.6455C36.0005 51.7675 36.3242 51.8279 36.6503 51.8233C36.9765 51.8187 37.2983 51.7492 37.5969 51.6188C37.8955 51.4884 38.1648 51.2998 38.3888 51.0642L43.0541 46.4273L47.7194 51.0642C48.1853 51.4721 48.7902 51.688 49.4107 51.668C50.0313 51.6481 50.6208 51.3936 51.0591 50.9566C51.4975 50.5196 51.7517 49.9329 51.7699 49.3161C51.7882 48.6993 51.5691 48.0988 51.1573 47.6369L46.5024 43Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_564_3581",
    x: 16.3702,
    y: 16.7277,
    width: 53.617,
    height: 53.617,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.42979
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.714894
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_564_3581"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_564_3581",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_564_3581",
    x1: 31.5618,
    y1: 1,
    x2: 43.5367,
    y2: 134.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_564_3581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 85,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.57eb9c96c34ed0c23623653a58af5f01.svg";
export { ForwardRef as ReactComponent };